import { useResponsiveGridLayout } from "@tudigo-monorepo/core-tudigo-utils";

import { ProjectCardSkeleton } from "../../../shared-external/components/project-card/skeletons/project-card.skeleton";
import { ProjectsCardGrid } from "../../../shared-external/components/projects-card-grid";
import { useFinishedSuggestedProjects } from "../../shared-internal/hooks/use-finished-suggested-projects";

function SuggestedProjects() {
  const { itemsPerPage } = useResponsiveGridLayout();
  const { suggestedProjects, isFetching } = useFinishedSuggestedProjects(10);

  if (isFetching) {
    return (
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
        {Array.from({ length: itemsPerPage }).map((_, index) => (
          <ProjectCardSkeleton key={index} />
        ))}
      </div>
    );
  }

  return <ProjectsCardGrid projects={suggestedProjects} />;
}

export { SuggestedProjects };
